import React, { useState } from "react";
import { useAuth } from "../contexts/Auth/AuthProvider";
import ForgotPassword from "../components/ForgotPassword";

const LoginRight = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgot, setForgot] = useState(false);

  const { login, error, isLoading } = useAuth();

  const handleLogin = async (e) => {
    // Prevent default form submission behavior
    if (e) e.preventDefault();
    
    // Only proceed if form is not loading and we have email and password
    if (!isLoading && email && password) {
      const { success } = await login({ email, password });
      if (success) {
        console.log("Login successful!");
      }
    }
  };

  if (forgot) {
    return <ForgotPassword onBackToLogin={() => setForgot(false)} />;
  }

  return (
    <div className="flex flex-col justify-center p-8 w-full md:w-1/2 bg-white">
      {/* Intro box */}
      <div className="w-full max-w-md mx-auto bg-brand-50 border-l-4 border-brand-500 p-4 mb-6 rounded-lg">
        <p className="text-ink font-medium text-center">
          Welcome! Please sign in to access the admin dashboard.
        </p>
      </div>

      {/* Heading */}
      <h2 className="text-3xl font-bold mb-2 text-black text-center">Sign In</h2>
      <p className="text-gray-600 text-sm mb-6 text-center">
        For accessing the admin data, please login with your credentials.
      </p>

      {error && (
        <p className="text-red-600 mb-4 text-center font-medium">{error}</p>
      )}

      {/* Wrap inputs in a form with onSubmit handler */}
      <form onSubmit={handleLogin} className="flex flex-col gap-4 w-full max-w-md mx-auto">
        <div className="flex flex-col">
          <label className="mb-1 text-black font-medium">Email</label>
          <input
            type="text"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 transition"
          />
        </div>

        <div className="flex flex-col">
          <label className="mb-1 text-black font-medium">Password</label>
          <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-brand-500/30 focus-within:border-brand-500 transition">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="flex-1 px-4 py-3 rounded-lg focus:outline-none focus:!shadow-none"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="px-4 text-gray-600 text-sm hover:text-black"
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
        </div>

        <button
          type="submit"  // Change to type="submit"
          disabled={isLoading}
          className={`w-full ${isLoading ? 'bg-gray-500' : 'bg-black hover:bg-gray-800'} text-white font-semibold py-3 rounded-lg transition`}
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
      </form>

      <p className="text-gray-600 text-sm mt-4 text-center">
        Forgot your password?{" "}
        <span
          className="text-brand-600 font-medium cursor-pointer hover:underline"
          onClick={() => setForgot(true)}
        >
          Reset
        </span>
      </p>
    </div>
  );
};

export default LoginRight;